<template>
    <div class="warning">
        <van-overlay class="overlay" :show="show" @click="hidewarning" :z-index="999">
            <div class="warning-wrapper flex-column align-center" @click.stop>

                <img class="warning-header-img" :src="pageImg" alt="" />
                <!-- <img class="warning-header-btn" @click="experienceGoldDetail" src="@/assets/images/mine/button.png"
                    alt="" /> -->

                <div class="warning-header-button" @click="experienceGoldDetail">
                    马上查看
                </div>

                <div class="text">
                    <div class="text-top">
                        <span class="text-top-left">￥</span>
                        <span class="text-top-right">50</span>
                    </div>
                    <div style="color:#F3615E;">
                        恭喜您获得50元优惠券礼包
                    </div>
                </div>
            </div>
            <div class="close" @click="hidewarning">
                <img src="@/assets/images/close.png" alt="" />
            </div>

        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "experienceGold",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: String,
    },
    data() {
        return {
            pageImg: require("@/assets/images/mine/redPackage.png"),
        };
    },
    methods: {
        handleShowwarning() {
            this.$emit("update:show");
        },
        hidewarning() {
            this.$emit("update:show", false);
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
        comfirm() {
            this.$emit("comfirm");
        },

        experienceGoldDetail() {
            this.$router.push({ name: "Voucher" });
        },
    },
};
</script>

<style lang="less" scoped>
.warning {
    .overlay {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .warning-wrapper {
        width: 718px;
        height: 751px;
        border-radius: 20px;

        margin-top: -100px;

        .warning-header-img {
            width: 718px;
            height: 751px;
        }

        .warning-header-btn {
            width: 257px;
            height: 73px;
            margin-top: -300px;
            cursor: pointer;
        }

        .warning-header-button {
            width: 257px;
            height: 73px;
            color: #F03945;
            display: flex;
            font-size: 30px;
            font-weight: bolder;
            align-items: center;
            justify-content: center;
            border-radius: 30px;


            background-image:
                linear-gradient(180deg, #FDE6B0 0%, #FDE6B0 30%, #FECB82 100%);
            margin-top: -300px;
            cursor: pointer;
        }

        .warning-result {
            font-size: 36px;
            color: #212121;
            margin: 48px 0;
        }

        .warning-description {
            font-size: 30px;
            color: #616161;
            line-height: 40px;
            padding: 0 38px;
        }

        .warning-confirm-btn {
            width: 512px;
            height: 70px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            margin-top: 50px;
            font-size: 32px;
            padding: 0 38px;
        }
    }

    .close {
        position: absolute;
        bottom: calc(50vh - 292px - 56px - 50px);
        left: 0;
        right: 0;
        margin: auto;
        width: 72px;
        height: 72px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .text {
        margin-top: -420px;
        text-align: center;

        .text-top {
            color: #F03945;
            font-weight: bolder;

            .text-top-left {
                font-size: 50px;
            }

            .text-top-right {
                font-size: 100px;
            }
        }
    }
}
</style>
